import React, { useState, useEffect } from 'react'
import { Empty, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { category, products } from "../../utils/schemas"
import CategoriesCard from '../../components/categories-card/'
import './style.css'
import BackButton from '../../components/back-button';

import ApiServices from "../../utils/apiServices"
import Loading from '../../components/loading';
import ProductCard from '../../components/product-card';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

const styles = {
  container: {
    position: "relative",
    zIndex: 1,
    maxWidth: '100%',
    margin: '0 auto',
  },
  icon: {
    position: "absolute",
    top: '60%',
    right: '20px',
    fontSize: '24px',
    color: '#fd0088',
    transform: 'translateY(-50%)',
    zIndex: 1,
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '30px',
    border: '3px solid #fd0088',
    fontSize: '16px',
    marginTop: '16px',
  },
};

export default function Categories() {
  const { getList } = ApiServices()

  const [isLoading, setIsLoading] = useState(true)
  const [categories, setCategories] = useState([])

  const [isSearch, setIsSearch] = useState(false)
  const [searchData, setSearchData] = useState(false)
  const [searchValue, setSearchValue] = useState(null)

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    getCategories()

  }, [])

  function getCategories() {
    setIsLoading(true)
    getList(category).then((response) => {
      let search_params = searchParams.get("search")

      setCategories(response.data)

      if (search_params) {
        onSearchProducts(search_params)
        setSearchValue(search_params)
      } else {
        setTimeout(() => {
          setIsLoading(false)
        }, 500);
      }
    }).catch((err) => {
      setCategories([])
    })
  }

  function onSearchProducts(searchParams = null) {
    setIsLoading(true)
    let param_search = searchParams ? searchParams : searchValue

    const getParams = {
      page: 1,
      search: param_search ?? null
    }


    if (!param_search || param_search === "") {
      setIsSearch(false)
      setSearchData([])
      setTimeout(() => {
        setIsLoading(false)
      }, 500);
      navigate(`/products`)

    } else {
      navigate(`/products?search=${param_search}`)

      getList(products, getParams).then((response) => {
        if (response.code === 200) {
          setIsSearch(true)
          setSearchData(response.data)
          setTimeout(() => {
            setIsLoading(false)
          }, 500);
        }
      }).catch((err) => {
        console.log('err :>> ', err);
      })
    }
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
        <BackButton />
      </div>
      <div style={styles.container}>
        <SearchOutlined onClick={() => onSearchProducts()} style={styles.icon} />
        <Input
          value={searchValue}
          onPressEnter={() => onSearchProducts()}
          type="text"
          placeholder="ค้นหาสินค้าทั้งหมด"
          style={styles.input}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>
      {isSearch ?
        <div style={{ marginBottom: 30 }}>
          <h1>สินค้าทั้งหมด</h1>
          {isLoading
            ? <Loading description={"กำลังค้นหาสินค้า " + searchValue} />
            : <div className='categories-container'>
              {searchData?.length > 0 ? searchData?.map((category, index) => {
                return <ProductCard key={index} navigate_to={`/products/${category.category_id}/${category.tag_id}/${category.id}`} name={category.name} image={category?.images[0]} />
              }) : <Empty description="ไม่มีรายการ" />}
            </div>
          }
        </div> :
        <div>
          {!isLoading && <h1>หมวดหมู่สินค้า</h1>}
          {isLoading
            ? <Loading description="กำลังโหลดหมวดหมู่สินค้า" />
            : <div className='categories-container'>
              {categories?.length > 0 ? categories?.map((category, index) => {
                return <CategoriesCard key={index} navigate_to={`/products/${category.id}`} name={category.name} image={category?.images[0]} />
              }) : <Empty description="ไม่มีรายการ" />}
            </div>
          }
        </div>}
    </div>
  )
}
